import { gql } from "@apollo/client";

export const GET_TOPBAR=gql`
query GetTopBar {
  getTopBar {
    id
    content
  }
}
`